export const OPERATOR_STATUS_ONLINE = 1;
export const OPERATOR_STATUS_OFFLINE = 0;
export const OPERATOR_STATUS_INVISIBLE = -1;

export type OperatorStatus = 1 | 0 | -1;